import { makeActionCreator } from '../../config/store/utils'
import { getProvidersAmount } from '../../services/charts'

export const PROVIDERSTYPE = 'PROVIDERSTYPE'
export const PROVIDERSTYPE_ERROR = 'PROVIDERSTYPE_ERROR'
export const PROVIDERSTYPE_SUCCESS = 'PROVIDERSTYPE_SUCCESS'
export const onProvidersType = makeActionCreator(PROVIDERSTYPE)
export const onProvidersTypeError = makeActionCreator(PROVIDERSTYPE_ERROR, 'payload')
export const onProvidersTypeSuccess = makeActionCreator(PROVIDERSTYPE_SUCCESS, 'payload')
export const onProvidersTypeThunk = (idEntity, year) => async dispatch => {
  dispatch(onProvidersType())

  try {
    const { data } = await getProvidersAmount({ idEntity, year })

    if (data.success !== 'OK') {
      return dispatch(onProvidersTypeError(data.errores))
    }

    const { payload: chartStructure } = data
    const csvStructure = [
      ['Año', 'Tamaño proveedor', 'Monto bruto anual (CLP)', 'N° de órdenes de compra', 'Monto porcentual'],
      ...chartStructure.map(item => [
        item.year,
        item.tamanoProveedor === 'NoClasificado' ? 'Sin Clasificación' : item.tamanoProveedor,
        item.montoBrutoCLPAnualTP,
        item.nroOCAnualTP,
        item.porcentaje
      ])
    ]

    return dispatch(onProvidersTypeSuccess({ chartStructure, csvStructure }))
  } catch (error) {
    return dispatch(onProvidersTypeError(error))
  }
}
